import { store } from '../store'

export default (to, from, next) => {
  // console.log('authgaurd to :', to)
  // console.log('authgaurd from :', from)
  if (store.getters.user) {
    next()
  } else {
    const thePath = '/signin' + '?fwdTo=' + encodeURIComponent(to.fullPath)
    next({ path: thePath, replace: true })
  }
}
